import React, { useEffect, useState, useRef, useCallback } from "react";
import { gsap } from "gsap";
import { motion } from "framer-motion";
import Select from "../Select";

// Components
import Modal from "../Modal";
import ProfileAdjustment from "./ModalIAIllustrations/ProfileAdjustment";
import GetStrenghWeakness from "./ModalIAIllustrations/GetStrenghWeakness";
import Clustering from "./ModalIAIllustrations/Clustering";
import UserCompetences from "./ModalIAIllustrations/UserCompetences";
import ApplicantAnalysis from "./ModalIAIllustrations/ApplicantAnalysis";

const ModalIA = (props) => {
  // const [selection, setSelection] = useState({});
  // const [showSelectors, setShowSelectors] = useState(false);
  // const [optionsIa, setOptionsIa] = useState({});
  const options = [
    { id: 1, text: "Ajuste perfiles para puestos específicos" },
    { id: 2, text: "Detección de fortalezas o debilidades frecuentes" },
    { id: 3, text: "Agrupamiento en Cluster por estilo de perfil" },
    {
      id: 4,
      text: "Potenciales ocultos. Usuarios con puntuaciones medias, pero muy altos en competencias estratégicas poco frecuentes",
    },
    { id: 5, text: "Análisis de un candidato específico" },
  ];

  const options_1 = {
    Dirección: [
      "Director de operaciones",
      "Director de RRHH",
      "Project Manager",
    ],
    "Ventas y Atención": [
      "Ejecutivo de ventas",
      "Representante atención cliente",
      "Key Account Manager",
    ],
    RRHH: [
      "Especialista selección personal",
      "Formador / Coach",
      "Consultor de RRHH",
    ],
    Creativos: [
      "Diseñador gráfico / UX-UI",
      "Especialista marketing digital",
      "Desarrollador productos/servicios",
    ],
    Técnicos: [
      "Ingeniero de procesos",
      "Analista de datos",
      "Arquitecto de software",
    ],
    Administrativos: [
      "Asistente de dirección",
      "Coordinador logístico",
      "Auditor / Control calidad",
    ],
  };

  const handleClick = (selected) => {
    console.log("Clic en:", selected);
      // props.iaSelection(selected);
    // props.handleSetSelection(selected);
    // setSelection(selected);
    if ([2, 3, 4].includes(selected.id)) {
      props.iaSelection(selected);
    } else {
      props.handleShowSelectors(selected);
    }
  };

  // const sendSelected = () => {
  //   props.iaSelection({ ...selection, ...optionsIa });
  // };

  console.log(props);
  return (
    <Modal isVisible={true} medium closeModal={props.closeModal}>
      <div>
        <h2 className="c-modal-ia__title">
          ¿SOBRE QUÉ TE GUSTARÍA PREGUNTAR A LA IA?
        </h2>
      </div>
      <>
        <div className="c-modal-ia__list">
          {options.map((option, index) => (
            <div
              className="c-modal-ia__list-item"
              key={index}
              onClick={() => handleClick(option)}
            >
              <div className="c-modal-ia__illustration">
                {option.id === 1 && <ProfileAdjustment />}
                {option.id === 2 && <GetStrenghWeakness />}
                {option.id === 3 && <Clustering />}
                {option.id === 4 && <UserCompetences />}
                {option.id === 5 && <ApplicantAnalysis />}
              </div>
              <span>{option.text}</span>
            </div>
          ))}
        </div>
      </>
    </Modal>
  );
};

export default ModalIA;
